var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { INDRAExtraSidebar } from '@ibe.components/shared/sidebar-views/ancillaries/extra-sidebar.indra.abstract';
import { FormBuilder } from '@angular/forms';
import { TRANSLATION_ANCILLARY_DETAILED, EXTRAS_ANCILLARY_LOUNGE, TRANSLATION_ANCILLARIES_TYPE, TRANSLATION_LOUNGE, TRANSLATION_ANCILLARY_TEXTS, TRANSLATION_ANCILLARY_TITLE, TRANSLATION_ANCILLARY_LABEL, ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE, EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS, TRANSLATION_ANCILLARY_SUBTITLE, TRANSLATION_ANCILLARY_ARIA_LABEL, SSR_CODE_LOUNGE_ACCESS_1, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP, ANCILLARY_PRODUCT_PACKS } from '@ibe.config';
import { SidebarService } from '@ibe/services/ui';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAMybService } from '@ibe/services';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRAPackService } from '../pack/pack.service.indra';
var INDRALoungeComponent = /** @class */ (function (_super) {
    __extends(INDRALoungeComponent, _super);
    function INDRALoungeComponent(sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, fb, bfmStorage, dateService, googleAnalytics, storageService, store, ibeAdminConfigService, currencyPipe, paymentInfoService, packService) {
        var _this = _super.call(this, sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_LOUNGE, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService) || this;
        _this.fb = fb;
        _this.bfmStorage = bfmStorage;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.currencyPipe = currencyPipe;
        _this.paymentInfoService = paymentInfoService;
        _this.packService = packService;
        _this.translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;
        _this.paxPurchaseFeatures = [];
        _this.allSubscriptions = [];
        _this.isMYB = false;
        _this.notificationDuration = 2.5; // in seconds
        _this.milesNeeded = 0;
        _this.addedAncillary = [];
        _this.isModificationDisallowed = false;
        _this.notEnoughMilesFlag = false;
        _this.loungeItems = [];
        _this.aggregateSale = null;
        _this.stops = [];
        _this.isElegibleFlag = true;
        _this.addedByPack = false;
        _this.formsPerPassenger = [];
        return _this;
    }
    INDRALoungeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.storageService.set('ancType', EXTRAS_ANCILLARY_LOUNGE);
        this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
        if (this.router.url.includes('/my-bookings/details'))
            this.isMYB = true;
        this.paramSubscription = this.route.params.subscribe(function (params) {
            _this.flightCardId = _this.route.snapshot.paramMap.get('flight');
            _this.flight = _this.bookingService.INDRA_getBookedFlight(_this.flightCardId);
            if (params.aggregateSale && params.aggregateSale != null && params.aggregateSale != undefined && params.aggregateSale != 'undefined') {
                _this.aggregateSale = params.aggregateSale;
            }
            _this.flightRouteInput = (!_this.aggregateSale) ? _this.bookingService.INDRA_getFlightRoute(_this.flight) : _this.bookingService.INDRA_getFlightRouteAggregate(_this.flight, _this.aggregateSale);
            if (_this.INDRA_hasNextOrPreviousFlight()) {
                //METHOD: ENABLE THIS FUNCTION ONLY FOR MULTIPLE FLIGHT CARDS
                _this.INDRA_loadChangeFlightCard(_this.flightRouteInput.idFlight);
            }
            _this.passengers = _this.bookingService.INDRA_getPaxInfo(false);
            _this.departureLocation = _this.INDRA_fetchDepartureLocation();
            _this.passengers.forEach(function (passenger) {
                return _this.formsPerPassenger.push(_this.createFormGroup());
            });
            _super.prototype.ngOnInit.call(_this);
            _this.allSubscriptions.push(_this.paramSubscription);
            // get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
            var isBookingCreatedParam = _this.route.snapshot.paramMap.get('isBookingCreated');
            if (isBookingCreatedParam === 'true') {
                _this.isModificationDisallowed = true;
            }
        });
        this.activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        var priceList = this.paxAddOnFeatures[this.flightCardId].map(Object.values).map(function (subarray) {
            return subarray.map(function (number) {
                return number.map(function (val) {
                    return val.price;
                });
            });
        });
        if (!this.INDRA_hasNextOrPreviousFlight()) {
            this.INDRA_loadSegmentedControlRadio();
        }
        var filteredPrice = priceList.map(function (nestedarr) { return nestedarr.find(function (element) { return element.length > 0; }); });
        this.startingPrice = filteredPrice.filter(function (value) { return value != undefined; }).reduce(function (a, b) { return Math.min(a, b); }).toString();
        for (var i in this.passengers) {
            var feature = this.INDRA_getAddedAncillariesForPassenger(this.passengers[i].idPax);
            if (feature) {
                var shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
                for (var x in feature) {
                    this.addedAncillary.push(feature[x]);
                    this.milesNeeded = this.milesNeeded + feature[x].points;
                }
                // this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature.type).payWithMiles;
            }
        }
        for (var i in this.passengers) {
            var feature = this.INDRA_getAddedAncillariesForPassengerSegment(this.passengers[i].idPax, this.selectedStop + 1);
            if (feature.length != 0) {
                var shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
                this.addedAncillary.push(feature);
                // this.milesNeeded = this.milesNeeded + feature[0].points;
                // this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature[0].type).payWithMiles;
            }
        }
        this.payWithMiles = this.INDRA_isPayWithMiles();
        // this.startingPrice = this.paxAddOnFeatures[1][0][1].reduce(((sum, item) => sum + (item.type === this.ancillariesType ? parseFloat(item.price.toString()) : 0)), 0);
        this.hasAddedExtrasFlag = this.INDRA_getInitialAddedExtras('LOUNGE');
        this.loungeItems = this.INDRA_buildLoungeItems();
    };
    INDRALoungeComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRALoungeComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRALoungeComponent.prototype.createFormGroup = function () {
        return this.fb.group({
            loungeAdd: null,
            weightCheck: false,
            dimensionCheck: false
        });
    };
    INDRALoungeComponent.prototype.INDRA_hasNextFlight = function () {
        return this.bookingService.INDRA_hasNextFlight(this.flightCardId) && this.INDRA_checkIfNextFlightCardhasLoungeOnFirstSegmentOnly();
    };
    INDRALoungeComponent.prototype.INDRA_copyToOtherFlights = function () {
    };
    INDRALoungeComponent.prototype.INDRA_flowActionsClasses = function () {
        return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
    };
    INDRALoungeComponent.prototype.INDRA_handleNext = function () {
        var nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
        if (nextFlightIdentifier > 0) {
            this.router.navigate([
                { outlets: { sidebar: ['ancillaries--lounge', { flight: nextFlightIdentifier }] } }
            ]);
        }
        else {
            _super.prototype.INDRA_handleClose.call(this);
        }
    };
    INDRALoungeComponent.prototype.INDRA_printAddButtonLabel = function (idPax) {
        var _this = this;
        var features = this.INDRA_getAddOnForPassenger(idPax);
        var activeFeature = [];
        if (features && features.length > 0) {
            activeFeature = features.map(function (data) {
                if (data && data.segmentId === (_this.flightStop.idInfoSegment)) {
                    return data;
                }
            });
            activeFeature = activeFeature.filter(function (element) {
                return element !== undefined && element != false;
            });
        }
        if (activeFeature.length) {
            return this.INDRA_getTranslation("" + (this.translationAncillaryDetailedKey + activeFeature[0].code))
                + ' ('
                + this.currencyPipe.transform((activeFeature[0].price)) + ' '
                + this.INDRA_getCurrencySymbol(activeFeature[0].currency)
                + ')';
        }
    };
    INDRALoungeComponent.prototype.INDRA_isElegibleWithLounge = function (idPax) {
        var _this = this;
        this.isElegibleFlag = true;
        var features = this.INDRA_getAddOnForPassenger(idPax);
        var activeFeature = [];
        if (features && features.length > 0) {
            activeFeature = features.map(function (data) {
                if (data && data.segmentId === (_this.flightStop.idInfoSegment)) {
                    return data;
                }
                else {
                    return false;
                }
            });
            activeFeature = activeFeature.filter(function (element) {
                return element !== undefined && element != false;
            });
        }
        if (!activeFeature || activeFeature.length <= 0) {
            this.isElegibleFlag = false;
        }
        this.INDRA_checkAncillaryInPack();
        return this.isElegibleFlag && !this.addedByPack;
    };
    INDRALoungeComponent.prototype.INDRA_checkAncillaryInPack = function () {
        var _this = this;
        if (this.shoppingCartContent.itemsAdded.length) {
            this.shoppingCartContent.itemsAdded.forEach(function (item) {
                if (ANCILLARY_PRODUCT_PACKS.includes(item.code)) {
                    // Item is pack
                    for (var i = 0; i < _this.activeBookedTrip['ancillaries-data'].packList.length; i++) {
                        var pack = _this.activeBookedTrip['ancillaries-data'].packList[i];
                        if (pack.ancillaryList[0].type === item.code && item.segmentId === _this.flightStop.idInfoSegment) {
                            if (pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.find(function (anc) { return anc.code === SSR_CODE_LOUNGE_ACCESS_1; })) {
                                _this.addedByPack = true;
                            }
                        }
                        else {
                            _this.addedByPack = false;
                        }
                    }
                }
            });
        }
        return this.addedByPack;
    };
    INDRALoungeComponent.prototype.INDRA_printAddedButtonLabel = function (idPax) {
        var _this = this;
        var features = [];
        var feature = [];
        features = this.INDRA_getAddedAncillariesForPassenger(idPax);
        if (features && features.length > 0) {
            feature = features.map(function (data) {
                if (data && data.segmentId === Number(_this.flightStop.idInfoSegment)) {
                    return data;
                }
            });
            feature = feature.filter(function (element) {
                return element !== undefined && element != false;
            });
        }
        return this.INDRA_getTranslation("" + (this.translationAncillaryDetailedKey + feature[0].code));
    };
    INDRALoungeComponent.prototype.INDRA_printRemoveButtonLabel = function (idPax) {
        var _this = this;
        var features = [];
        var feature = [];
        if (this.ancillariesType === EXTRAS_ANCILLARY_LOUNGE) {
            features = this.INDRA_getAddedAncillariesForPassenger(idPax);
            if (features && features.length > 0) {
                feature = features.map(function (data) {
                    if (data && data.segmentId === Number(_this.flightStop.idInfoSegment)) {
                        return data;
                    }
                });
                feature = feature.filter(function (element) {
                    return element !== undefined && element != false;
                });
            }
        }
        else {
            features = this.INDRA_getAddedAncillariesForPassenger(idPax);
            feature = features;
        }
        return feature[0].price + this.INDRA_getCurrencySymbol(feature[0].currency);
    };
    INDRALoungeComponent.prototype.INDRA_getTitle = function () {
        return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARIES_TYPE + EXTRAS_ANCILLARY_LOUNGE));
    };
    INDRALoungeComponent.prototype.INDRA_getSubTitle = function (key1, key2) {
        var keyValue1 = this.INDRA_getTranslation("" + (TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_SUBTITLE + key1));
        var keyValue2 = this.INDRA_getTranslation("" + (TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_SUBTITLE + key2));
        var currency = this.activeBookedTrip['ancillaries-data']['bundleList'][0].ancillaryList[0].catalog[0].passengers[0].codeList[0].currency;
        var price = this.startingPrice ? this.startingPrice.split(',')[0] : null;
        var startingPriceFormat = this.currencyPipe.transform(price);
        return keyValue1 + ' ' + startingPriceFormat + this.INDRA_getCurrencySymbol(currency ? currency : '') + ' ' + keyValue2;
    };
    INDRALoungeComponent.prototype.INDRA_printDepartureLocation = function () {
        return this.departureLocation;
    };
    INDRALoungeComponent.prototype.INDRA_fetchDepartureLocation = function () {
        var departureLocationObj = this.bookingService.INDRA_DepartureLocationOfFlight(this.flightCardId.toString());
        if (departureLocationObj) {
            return departureLocationObj.name;
        }
        return '';
    };
    INDRALoungeComponent.prototype.INDRA_getTextTranslation = function (lastKey) {
        var key = TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_TEXTS + lastKey;
        return key;
    };
    INDRALoungeComponent.prototype.INDRA_getTitleTranslation = function (lastKey) {
        var key = TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_TITLE + lastKey;
        return key;
    };
    INDRALoungeComponent.prototype.INDRA_getLabelTranslation = function (lastKey) {
        var key = TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_LABEL + lastKey;
        return key;
    };
    INDRALoungeComponent.prototype.INDRA_getAriaLabelTranslation = function (lastKey) {
        var key = TRANSLATION_LOUNGE + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey;
        return key;
    };
    INDRALoungeComponent.prototype.INDRA_checkIfNextFlightCardhasLoungeOnFirstSegmentOnly = function () {
        var nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
        var flight_tickets = this.bfmStorage.INDRA_getFlightTickets();
        var nextFlightCardsInfo = flight_tickets.filter(function (ticket) {
            if (ticket.type === 'flight' && ticket.item.details.assignedFlightId == nextFlightIdentifier) {
                return true;
            }
            return false;
        });
        return (nextFlightCardsInfo.length > 0 && nextFlightCardsInfo[0].item.extras.includes(EXTRAS_ANCILLARY_LOUNGE) ? true : false);
    };
    INDRALoungeComponent.prototype.INDRA_constructAncillaryListForPurchased = function (list) {
        var returnValue = [];
        list.forEach(function (segment) {
            returnValue.push({
                ancillaryDetail: '',
                segmentId: segment.segmentId,
                unconfirmed: segment.ancillaryList[0].unconfirmed
            });
        });
        return returnValue;
    };
    INDRALoungeComponent.prototype.INDRA_getPurchasedAncillaryForPassenger = function (idPax) {
        var returnValue = [];
        var index = this.paxPurchaseFeatures.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (this.paxPurchaseFeatures) {
            var paxAncillary = this.paxPurchaseFeatures[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRALoungeComponent.prototype.INDRA_isPresentOnFareInformation = function () {
        return this.bookingService.INDRA_isPresentOnFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE, this.flightCardId);
    };
    INDRALoungeComponent.prototype.INDRA_isPassengerPresentOnTierLevel = function (passengers) {
        if (passengers === void 0) { passengers = []; }
        return this.bookingService.INDRA_isPassengerPresentOnTierLevel(ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE, passengers);
    };
    INDRALoungeComponent.prototype.INDRA_getStopoverNotificationTitle = function () {
        return this.INDRA_getTranslation('addMoreSidebars.lounge.titles.extraForWhole') + ' '
            + this.INDRA_getBoundType() + ' ' +
            this.INDRA_getTranslation('addMoreSidebars.lounge.titles.trip');
    };
    /**
     * 	For Lounge, since it is only being sold for the first segment,
     * 	flight route should consist of the first 'flight' segment. Bus and Train segments are ignored.
     */
    INDRALoungeComponent.prototype.INDRA_getFlightRoute = function () {
        var flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
        if (flightRouteInput && flightRouteInput.listSegment) {
            var flightSegments = flightRouteInput.listSegment.filter(function (segment) {
                return (segment.equipment !== EQUIPMENT_CODE_TRAIN && segment.equipment !== EQUIPMENT_CODE_BUS);
            });
            if (flightSegments && flightSegments.length > 0) {
                var newFlightRouteInput = {
                    listSegment: flightSegments.splice(0, 1),
                    fareFamily: flightRouteInput.fareFamily,
                    idFlight: flightRouteInput.idFlight
                };
                return newFlightRouteInput;
            }
        }
        return flightRouteInput;
    };
    INDRALoungeComponent.prototype.showNotification = function (message) {
        this.notificationMessage = this.INDRA_getTranslation(message);
        this.notificationShowing = true;
        window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);
        this.lastActiveElement = document.activeElement;
        // this.$notification.nativeElement.focus();
    };
    INDRALoungeComponent.prototype.dismissNotification = function () {
        this.notificationShowing = false;
        this.lastActiveElement.focus();
    };
    INDRALoungeComponent.prototype.INDRA_addAncillary = function (passenger) {
        var _this = this;
        var selStop = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax) && this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).length > 1 ? this.selectedStop : 0;
        var selStopSegIndex;
        if (this.INDRA_getAddOnForPassenger(passenger.idPax) && this.INDRA_getAddOnForPassenger(passenger.idPax).length > 1) {
            this.INDRA_getAddOnForPassenger(passenger.idPax).map(function (data, index) {
                if (data.segmentId == (_this.flightStop.idInfoSegment)) {
                    selStopSegIndex = index;
                }
            });
        }
        else {
            selStopSegIndex = 0;
        }
        this.hasAddedExtrasFlag = this.INDRA_handleAddAncillary(this.INDRA_getAddOnForPassenger(passenger.idPax)[selStopSegIndex]);
        var ancillaryDetails = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax)[selStop];
        this.addedAncillary.push(ancillaryDetails);
        this.milesNeeded = this.milesNeeded + (ancillaryDetails ? ancillaryDetails.points : 0);
    };
    INDRALoungeComponent.prototype.INDRA_removeAncillary = function (passenger) {
        var _this = this;
        var selStopSegIndex;
        if (this.INDRA_getAddedAncillariesForPassenger(passenger.idPax) && this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).length > 1) {
            this.INDRA_getAddedAncillariesForPassenger(passenger.idPax).map(function (data, index) {
                if (data.segmentId == (_this.flightStop.idInfoSegment)) {
                    selStopSegIndex = index;
                }
            });
        }
        else {
            selStopSegIndex = 0;
        }
        this.removedAncillary = this.INDRA_getAddedAncillariesForPassenger(passenger.idPax)[selStopSegIndex];
        this.addedAncillary = this.addedAncillary.filter(function (item) { return item.paxId != _this.removedAncillary.paxId && item.segmentId != _this.removedAncillary.segmentId; });
        this.hasAddedExtrasFlag = this.INDRA_handleRemoveAncillary(this.removedAncillary);
        this.milesNeeded = this.milesNeeded - this.removedAncillary.points;
        sessionStorage.removeItem("is" + EXTRAS_ANCILLARY_LOUNGE + "withMiles");
        this.INDRA_checkMiles();
    };
    INDRALoungeComponent.prototype.INDRA_processAncillary = function () {
        this.notEnoughMilesFlag = this.INDRA_handleProcessAncillaries(EXTRAS_ANCILLARY_LOUNGE, this.addedAncillary, this.milesNeeded, this.booked_trip);
    };
    INDRALoungeComponent.prototype.INDRA_buildLoungeItems = function () {
        var items = [
            this.INDRA_getTranslation(this.INDRA_getTextTranslation('wifi')),
            this.INDRA_getTranslation(this.INDRA_getTextTranslation('shower')),
            this.INDRA_getTranslation(this.INDRA_getTextTranslation('kidsArea')),
            this.INDRA_getTranslation(this.INDRA_getTextTranslation('restingSpace')),
            this.INDRA_getTranslation(this.INDRA_getTextTranslation('workingSpace')),
        ];
        var activeItems = items.filter(function (el) { return el.trim(); });
        return activeItems;
    };
    INDRALoungeComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRALoungeComponent.prototype.INDRA_loadChangeFlightCard = function (incomingFlightId) {
        var idFlight;
        if (!this.prevFlightId || this.prevFlightId != incomingFlightId) {
            idFlight = incomingFlightId;
        }
        else {
            idFlight = this.prevFlightId;
        }
        // this.router.navigate([
        // 	{ outlets: { sidebar: ['preferred-boarding', { flight: idFlight }] } }
        // ]);
        this.stops = [];
        this.selectedStop = null;
        this.INDRA_loadSegmentedControlRadio();
    };
    INDRALoungeComponent.prototype.INDRA_loadSegmentedControlRadio = function () {
        //fills input for segmented control radio
        var segmentIndex = 0;
        var firstSegmentId = 0;
        for (var i = 0; i < this.flight.listSegment.length; i++) {
            var segment = this.flight.listSegment[i];
            this.stops.push({
                label: segment.departureAirport + '-' + segment.arrivalAirport,
                value: segmentIndex
            });
            var idInfoSegment = segment.idInfoSegment;
            if (segmentIndex === 0) {
                firstSegmentId = idInfoSegment;
            }
            segmentIndex++;
        }
        if (!this.selectedStop) {
            this.INDRA_selectedStop(0); //first segment of the flight
        }
    };
    INDRALoungeComponent.prototype.INDRA_selectedStop = function (value) {
        this.selectedStop = value;
        this.flightStop = this.flight.listSegment[this.selectedStop];
    };
    INDRALoungeComponent.prototype.INDRA_hasActiveAncillaryOnSegment = function (idPax, segmentId) {
        var addedAnc = this.INDRA_getAddedAncillariesForPassenger(idPax);
        var flag = false;
        if (addedAnc && addedAnc.length > 0) {
            addedAnc.map(function (data) {
                if (data.segmentId === segmentId) {
                    flag = true;
                }
            });
        }
        return flag;
    };
    INDRALoungeComponent.prototype.INDRA_getLocation = function (code) {
        return this.bookingService.INDRA_getLocation(code).city;
    };
    INDRALoungeComponent.prototype.INDRA_checkMiles = function () {
        var shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
        var loungeItems = [];
        if (shoppingCartItems.itemsAdded.length === 0) {
            return false;
        }
        else if (shoppingCartItems.itemsAdded.length != 0) {
            for (var i in shoppingCartItems.itemsAdded) {
                if (shoppingCartItems.itemsAdded[i].code === "LOUG") {
                    loungeItems.push(shoppingCartItems.itemsAdded[i]);
                    if (loungeItems.length < 1) {
                        return false;
                    }
                    var isPaidWithMiles = sessionStorage.getItem("is" + shoppingCartItems.itemsAdded[i].type + "withMiles");
                    if (isPaidWithMiles === null) {
                        return false;
                    }
                    if (String(shoppingCartItems.itemsAdded[i].payWithMiles) === isPaidWithMiles) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    return INDRALoungeComponent;
}(INDRAExtraSidebar));
export { INDRALoungeComponent };
